type QueryParams = Record<string, string | number | boolean | null | undefined>;

/**
 * Builds the query string of a GET request for an `@rest` path (`path: "/v2/x{args.queryString}"`).
 *
 * A param that is `null`, `undefined` or `''` is left out and the rest are URL-encoded the way the
 * request client used to: the `@rest` path cannot leave a param out and would send `undefined` or an
 * empty value, which some endpoints reject or read differently.
 *
 * @returns `''` when no param is left, otherwise `?a=1&b=2`
 */
export const buildRestQueryString = (params: QueryParams): string => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([name, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            searchParams.append(name, String(value));
        }
    });

    const queryString = searchParams.toString();

    return queryString === '' ? '' : `?${queryString}`;
};
